// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.glyph-overlay-background {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1500;
  touch-action: none; /* Отключаем стандартные жесты на фоне */
  overscroll-behavior: none; /* Отключаем прокрутку за пределами */
  -webkit-user-select: none; /* Отключаем выделение текста */
  user-select: none;
}

.glyph-editor-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1500;
  display: flex;
  flex-direction: column;
  align-items: center;
  touch-action: none; /* Отключаем стандартные жесты в контейнере */
  overscroll-behavior: none; /* Отключаем прокрутку за пределами */
  -webkit-user-select: none; /* Отключаем выделение текста */
  user-select: none;
}

.glyph-editor-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.glyph-editor-buttons {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  align-items: center;
}

/* Стили для canvas */
.glyph-editor-container canvas {
  touch-action: none; /* Отключаем стандартные жесты на канвасе */
  overscroll-behavior: none; /* Отключаем прокрутку за пределами */
  -webkit-user-select: none; /* Отключаем выделение текста */
  user-select: none;
  -webkit-tap-highlight-color: transparent; /* Отключаем подсветку при касании на iOS */
}

/* Стили для кнопки "Назад" */
.glyph-action-button.undo-button {
  width: 30px;
  height: 30px;
  background: none;
  border: 2px solid rgba(115, 185, 255, 0.3);
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--tg-theme-text-color);
  opacity: 0.7;
  transition: all 0.2s ease;
}

.glyph-action-button.undo-button:hover {
  background-color: rgba(154, 154, 154, 0.12);
  border-color: var(--tg-theme-button-color);
  opacity: 1;
}

/* Иконка внутри кнопки "Назад" */
.glyph-action-button.undo-button svg {
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/menus/brush/GlyphEditor.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,kBAAkB,EAAE,wCAAwC;EAC5D,yBAAyB,EAAE,qCAAqC;EAChE,yBAAyB,EAAE,+BAA+B;EAC1D,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB,EAAE,6CAA6C;EACjE,yBAAyB,EAAE,qCAAqC;EAChE,yBAAyB,EAAE,+BAA+B;EAC1D,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB,EAAE,2CAA2C;EAC/D,yBAAyB,EAAE,qCAAqC;EAChE,yBAAyB,EAAE,+BAA+B;EAC1D,iBAAiB;EACjB,wCAAwC,EAAE,2CAA2C;AACvF;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".glyph-overlay-background {\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 1500;\r\n  touch-action: none; /* Отключаем стандартные жесты на фоне */\r\n  overscroll-behavior: none; /* Отключаем прокрутку за пределами */\r\n  -webkit-user-select: none; /* Отключаем выделение текста */\r\n  user-select: none;\r\n}\r\n\r\n.glyph-editor-container {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n  z-index: 1500;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  touch-action: none; /* Отключаем стандартные жесты в контейнере */\r\n  overscroll-behavior: none; /* Отключаем прокрутку за пределами */\r\n  -webkit-user-select: none; /* Отключаем выделение текста */\r\n  user-select: none;\r\n}\r\n\r\n.glyph-editor-title {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.glyph-editor-buttons {\r\n  margin-top: 10px;\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n/* Стили для canvas */\r\n.glyph-editor-container canvas {\r\n  touch-action: none; /* Отключаем стандартные жесты на канвасе */\r\n  overscroll-behavior: none; /* Отключаем прокрутку за пределами */\r\n  -webkit-user-select: none; /* Отключаем выделение текста */\r\n  user-select: none;\r\n  -webkit-tap-highlight-color: transparent; /* Отключаем подсветку при касании на iOS */\r\n}\r\n\r\n/* Стили для кнопки \"Назад\" */\r\n.glyph-action-button.undo-button {\r\n  width: 30px;\r\n  height: 30px;\r\n  background: none;\r\n  border: 2px solid rgba(115, 185, 255, 0.3);\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--tg-theme-text-color);\r\n  opacity: 0.7;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.glyph-action-button.undo-button:hover {\r\n  background-color: rgba(154, 154, 154, 0.12);\r\n  border-color: var(--tg-theme-button-color);\r\n  opacity: 1;\r\n}\r\n\r\n/* Иконка внутри кнопки \"Назад\" */\r\n.glyph-action-button.undo-button svg {\r\n  width: 16px;\r\n  height: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
